import { lightFormat, parseISO } from 'date-fns'

const formatDate = (date?: Date | string | null): string => {
  if (!date) {
    return ''
  }

  if (typeof date === 'string') {
    date = parseISO(date)
  }

  return lightFormat(date, 'MM/dd/yyyy')
}

export default formatDate
